export const STATUS_IDLE = 'idle';
export const STATUS_PENDING = 'pending';
export const STATUS_FAILURE = 'failure';
export const STATUS_SUCCESS = 'success';

export const STAGE_STAGING = 'staging';
export const STAGE_LIVE = 'live';
